import React, { ReactNode, useContext } from 'react';
import { defaultConfigurations, DynamicConfigurations } from './config';

interface DynamicConfigContext {
  config: DynamicConfigurations;
}

interface CreateConfigProviderProps {
  children: ReactNode;
  /** Config fetched before React mount by bootstrap in main.tsx */
  initialConfig: DynamicConfigurations;
}

const configContextObject = React.createContext<DynamicConfigContext>({
  config: defaultConfigurations,
});

export const ConfigContextProvider: React.FC<CreateConfigProviderProps> = ({
  children,
  initialConfig,
}) => {
  return (
    <configContextObject.Provider
      value={{
        config: initialConfig,
      }}
    >
      {children}
    </configContextObject.Provider>
  );
};

export const useConfig = () => useContext(configContextObject);
